import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const MaritalStatus: FC<IFieldFactoryProps> = (props) => {
  const { maritalStatuses } = useDictionaries(['maritalStatuses']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={maritalStatuses}
      withCrossIcon={false}
    />
  );
};
